import { FieldTypes } from '../../constants/FieldTypes'
import { addCondition } from '../../fields/utils'
import {
  CheckboxField,
  DateField,
  DateTimeField,
  FieldMap,
  TextAreaField,
  TextField,
} from '../../types/forms/fields'

const newbornScreenOrderedField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Newborn screen ordered',
}

const orderedDateField: DateField = addCondition(
  {
    type: FieldTypes.DATE,
    placeholder: 'Order date',
    optional: true,
  },
  v => !!v?.newbornScreenOrdered,
)

const collectionDateTimeField: DateTimeField = {
  type: FieldTypes.DATETIME,
  placeholder: 'Collection date / time',
}

const screenKitIdField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Screen kit ID / card number',
  optional: true,
}

const resultTextField: TextField = {
  type: FieldTypes.TEXT,
  placeholder: 'Result',
  optional: true,
}

const receivedDateField: DateField = {
  type: FieldTypes.DATE,
  placeholder: 'Date received',
  optional: true,
}

const resultsReceivedField: FieldMap = {
  name: 'Results Received',
  optional: true,
  children: {
    result: resultTextField,
    receivedDate: receivedDateField,
    abnormal: {
      type: FieldTypes.CHECKBOX,
      placeholder: 'Abnormal result',
      optional: true,
    } as CheckboxField,
  },
}

const abnormalFollowUpField: TextAreaField = addCondition(
  {
    type: FieldTypes.TEXTAREA,
    placeholder: 'Abnormal screen follow-up plan',
  },
  v => !!v?.resultsReceived?.abnormal,
)

export const pkuScreenField: FieldMap = {
  name: 'Newborn PKU / State Metabolic Screen',
  children: {
    newbornScreenOrdered: newbornScreenOrderedField,
    orderedDate: orderedDateField,
    collectionDateTime: collectionDateTimeField,
    screenKitId: screenKitIdField,
    resultsReceived: resultsReceivedField,
    abnormalFollowUp: abnormalFollowUpField,
  },
}
